import { useTranslation } from "react-i18next"
import { Tag, TagVariant } from "@/components/ui/tag"
import { AppointmentTagVariant } from "@/types/__generated__/union-types"

export const APPOINTMENT_TAG_VARIANT_MAP: Record<AppointmentTagVariant, TagVariant> = {
  CRITICAL: "critical",
  MOST_CRITICAL: "most-critical",
  WARNING: "warning",
  NEUTRAL: "neutral",
  SUCCESS: "success",
  ATTENTION: "attention",
}

export const PartnerTypeAppointmentTags = ({
  tags,
}: {
  tags: ReadonlyArray<{ variant: AppointmentTagVariant; value: string }>
}) => {
  const { t } = useTranslation()

  return tags.map((tag) => (
    <Tag
      key={tag.value}
      data-testid={`appointment-tag-${tag.value}`}
      type={APPOINTMENT_TAG_VARIANT_MAP[tag.variant]}
      label={t(`scheduling.waitingRoom.partnerTypeOptions.${tag.value}`)}
    />
  ))
}
